import { STATE_KEYS } from "utils/constants/state";
import { getFieldPath } from "utils/form";
import get from "lodash/get";
import { useFormikContext } from "formik";

export const useFieldGroups = (name) => {
  const { values } = useFormikContext();

  const path = getFieldPath(name, STATE_KEYS.FORM.FIELD_GROUPS);
  return get(values, path, []);
};

export const useFieldGroupsFields = (name) => {
  const { values } = useFormikContext();
  const path = getFieldPath(name, STATE_KEYS.FORM.FIELD_GROUPS);

  return get(values, path, []).reduce((memo, fieldGroup) => {
    if (fieldGroup && Array.isArray(fieldGroup.fields)) {
      fieldGroup.fields.forEach((field) => {
        memo.push(field);
      });
    }
    return memo;
  }, []);
};
